export default __webpack_public_path__ + "a7db4cc916fea2930e0a47b4e1fd8824.png";